import { useEffect, useState } from "react";
import { gerIPFReport } from "../../../../../services/customers/customers.services";
import ApexChart from "./Chart.component";
import SalesHistory from "./SalesHistory.component";
import { Box, Card } from "@mui/material";

export const SalesChart = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const getReportsData = async () => {
    const result = await gerIPFReport();
    setData(result.data);
    setIsLoading(false);
  };

  useEffect(() => {
    getReportsData();
  }, []);

  if (isLoading) {
    return <></>;
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "1rem", padding: "1rem" }}>
      <Card
        sx={{
          bgcolor: "#011a3d",
          borderRadius: 6,
          boxShadow: 24,
          p: 4,
          color: "#fff",
        }}
      >
        Ventas totales: {' '}
        {data.total.toLocaleString("en-US", {
          style: "currency",
          currency: "USD",
        })}
      </Card>
      <Box
        sx={({ breakpoints }) => ({
          display: "flex",
          gap: "2rem",
          flexDirection: "row",
          [breakpoints.down("md")]: {
            flexDirection: "column",
          },
        })}
      >
        <Card
          sx={({ breakpoints }) => ({
            width: "65%",
            [breakpoints.down("xl")]: {
              width: "100%",
            },
          })}
        >
          <ApexChart items={data.items} />
        </Card>
        <Card
          sx={({ breakpoints }) => ({
            display: "flex",
            width: "35%",
            [breakpoints.down("xl")]: {
              display: "none",
            },
          })}
        >
          <SalesHistory items={data.items} />
        </Card>
      </Box>
    </div>
  );
};
